import { IMethodRouter } from 'runtime/methodrouter';

export class SaveCloneRequested {
    static eventName() { return 'SaveCloneRequested' }
    eventName = SaveCloneRequested.eventName;

    constructor(public methods: IMethodRouter, public done: () => void) { }
}